<template>
  <div id="app-welfare">
    <div class="welfare-box">
      <div class="welfare-bottom">
        <div class="content-box"
             v-for="(item,index) in newList"
             :key="index">
          <router-link to="/projectDetails">
            <div class="img-box">
              <img src="../../assets/images/news.png"
                   alt>
            </div>
            <div class="con-box">
              <h3>{{item.title}}</h3>
              <p>{{item.content}}</p>
              <!-- <ul>
                <li>
                  <h5>{{item.aims}}</h5>
                  <p>目标筹款/元</p>
                </li>
                <li>
                  <h5>{{item.current}}</h5>
                  <p>当前筹款/元</p>
                </li>
              </ul> -->
            </div>
          </router-link>
        </div>
      </div>
      <div class="page-box">
        <el-pagination background
                       layout="prev, pager, next"
                       :total="1000"></el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      classHide: false,
      classShow: true,
      newList: [
        {
          id: 1,
          title: "角膜盲救助行动",
          content: "每筹集3万元，帮助一名贫困角膜盲症患者重获光明",
          aims: "3,300,000",
          current: "1,901,758.07"
        },
        {
          id: 1,
          title: "角膜盲救助行动",
          content: "每筹集3万元，帮助一名贫困角膜盲症患者重获光明",
          aims: "3,300,000",
          current: "1,901,758.07"
        },
        {
          id: 1,
          title: "角膜盲救助行动",
          content: "每筹集3万元，帮助一名贫困角膜盲症患者重获光明",
          aims: "3,300,000",
          current: "1,901,758.07"
        },
        {
          id: 1,
          title: "角膜盲救助行动",
          content: "每筹集3万元，帮助一名贫困角膜盲症患者重获光明",
          aims: "3,300,000",
          current: "1,901,758.07"
        },
        {
          id: 1,
          title: "角膜盲救助行动",
          content: "每筹集3万元，帮助一名贫困角膜盲症患者重获光明",
          aims: "3,300,000",
          current: "1,901,758.07"
        },
        {
          id: 1,
          title: "角膜盲救助行动",
          content: "每筹集3万元，帮助一名贫困角膜盲症患者重获光明",
          aims: "3,300,000",
          current: "1,901,758.07"
        }
      ]
    };
  },
  mounted () {
    window.addEventListener("scroll", this.isElementInViewport, true);
  },
  methods: {
    isElementInViewport () {
      let el = document.getElementById("app-welfare");
      let top = el.offsetTop;
      let lTop = document.documentElement.clientHeight;
      let b = top + 50 - lTop;
      var scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop;
      if (scrollTop > b) {
        this.classHide = true;
      } else {
        this.classHide = false;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
#app-welfare {
  width: 100%;
  margin-bottom: 45px;
}
.welfare-box {
  max-width: 1300px;
  margin: 0 auto;
  margin-top: 82px;
  .welfare-bottom {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    .content-box {
      width: calc(100% / 3);
      margin-bottom: 52px;
      cursor: pointer;
      transition: ease-out 0.6s;
      &:hover {
        transform: scale(1, 1.05);
        box-shadow: 0px 0px 35px 0px rgba(9, 1, 4, 0.21);
        > a {
          .con-box {
            background-color: #c30d23;
            transition: all 1.5s;
            > h3 {
              color: #fff;
            }
            > p {
              color: #fff;
            }
            > ul {
              > li {
                > h5 {
                  color: #fff;
                }
                > p {
                  color: #740f1b;
                }
              }
            }
          }
        }
      }
      > a {
        .img-box {
          width: 100%;
          height: 290px;
          > img {
            width: 100%;
            height: 100%;
          }
        }
        .con-box {
          padding: 28px 50px;
          > h3 {
            font-size: 18px;
            color: #333333;
            margin-bottom: 8px;
            overflow: hidden; /*超出部分隐藏*/
            white-space: nowrap; /*不换行*/
            text-overflow: ellipsis; /*超出部分省略号显示*/
          }
          > p {
            font-size: 14px;
            color: #999;
            overflow: hidden; /*超出部分隐藏*/
            white-space: nowrap; /*不换行*/
            text-overflow: ellipsis; /*超出部分省略号显示*/
          }
          > ul {
            display: flex;
            margin-top: 30px;
            > li {
              width: 50%;
              list-style: none;
              > h5 {
                font-size: 18px;
                color: #333333;
                margin-bottom: 8px;
                overflow: hidden;
              }
              > p {
                font-size: 14px;
                color: #999;
              }
            }
          }
        }
      }
    }
  }
  .page-box {
    text-align: center;
    margin-top: 20px;
  }
}
.page-box
  /deep/
  .el-pagination.is-background
  .el-pager
  li:not(.disabled).active {
  background-color: #c30d23;
  color: #fff;
}
.page-box /deep/ .el-pagination.is-background .el-pager li {
  background-color: #fff;
  border: solid 1px #dddddd;
  color: #999;
}
.page-box
  /deep/
  .el-pagination.is-background
  .el-pager
  li:not(.disabled):hover {
  color: #c30d23;
}
</style>



// WEBPACK FOOTER //
// src/components/Project/project.vue